import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { Link } from '../../atoms/Link/Link';
import { useTranslation } from '../../i18n/resources';
import { emails, phoneNumbers } from '../../services/contacts';
import styles from './ContactInfo.module.css';

export type ContactInfoProps = {
  className?: string;
};

export const ContactInfo: FunctionComponent<ContactInfoProps> = ({
  className,
}) => {
  const { renderTrans, t } = useTranslation();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.hours}>{renderTrans('common', 'hours')}</div>
      <div className={cx(styles.buttons, className)}>
        <div className={styles.contact}>
          <Link
            className={styles.contactButton}
            href={phoneNumbers.memberServices.href}
            // startIcon={<CallIcon />}
            type="button"
          >
            {t('common', 'call')}
          </Link>
        </div>
        <div className={styles.contact}>
          <Link
            className={styles.contactButton}
            href={emails.memberServices.href}
            // startIcon={<EmailIcon />}
            type="button"
          >
            {t('common', 'email')}
          </Link>
        </div>
      </div>
      <div className={styles.emailAddress}>{emails.memberServices.address}</div>
      <div>{phoneNumbers.memberServices.number}</div>
    </div>
  );
};
